/* eslint-disable @typescript-eslint/no-explicit-any */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useEffect, useState } from 'react';
import { useField } from 'formik';
import { FormText, useMediaSize } from '@ally/metronome-ui';
import { asCurrency, convertNumericStringToNumber, currencyInputFormatter, mobileCurrencyInputFormatter, } from '@ally/aos-utils';
import { useRegisterError } from '../utils';
export var defaultValidate = function (value) {
    var match = value !== null && value > 0;
    if (!match) {
        return 'Please enter an amount.';
    }
    return undefined;
};
var toAmount = function (localValue) {
    return localValue ? convertNumericStringToNumber(localValue) : null;
};
var Amount = function (_a) {
    var validate = _a.validate, useDefaultValidate = _a.useDefaultValidate, name = _a.name, onBlur = _a.onBlur, onFocus = _a.onFocus, onChange = _a.onChange, _b = _a.label, label = _b === void 0 ? 'Amount' : _b, props = __rest(_a, ["validate", "useDefaultValidate", "name", "onBlur", "onFocus", "onChange", "label"]);
    var selectedValidation = validate || (useDefaultValidate ? defaultValidate : undefined);
    var _c = __read(useField(__assign(__assign({}, props), { name: name, validate: selectedValidation })), 3), field = _c[0], meta = _c[1], helpers = _c[2];
    var refValue = useRegisterError(meta.error).refValue;
    var isLgUp = useMediaSize('LgUp');
    var currencyFormatter = isLgUp
        ? currencyInputFormatter
        : mobileCurrencyInputFormatter;
    var _d = __read(useState(''), 2), localValue = _d[0], setLocalValue = _d[1];
    var _e = __read(useState((refValue === null || refValue === void 0 ? void 0 : refValue.current) === document.activeElement), 2), isFocused = _e[0], setIsFocused = _e[1];
    var displayValue = useMemo(function () {
        if (!isFocused && localValue)
            return asCurrency(localValue);
        return localValue;
    }, [isFocused, localValue]);
    useEffect(function () {
        /**
         * If the value coming from formik is the same as what the local value
         * converts to, then we don't need to update anything locally
         */
        if (field.value === toAmount(localValue))
            return;
        var getLocalValue = function () {
            if (field.value === null)
                return '';
            return currencyFormatter(asCurrency(field.value.toString()));
        };
        setLocalValue(getLocalValue());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value]);
    var combinedOnBlur = function (e) {
        field.onBlur(e);
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    };
    var combinedOnFocus = function (e) {
        setIsFocused(true);
        if (onFocus) {
            onFocus(e);
        }
    };
    var combinedOnChange = function (e) {
        var newLocalValue = currencyFormatter(e.target.value);
        setLocalValue(newLocalValue);
        helpers.setValue(toAmount(newLocalValue));
        // Formik is causing validation to briefly show error onBlur even though no error exists
        // https://github.com/formium/formik/issues/2841
        if (!meta.touched) {
            helpers.setError(undefined);
        }
        if (onChange) {
            onChange(e);
        }
    };
    var errorMessage = meta.touched ? meta.error : '';
    return (React.createElement(FormText, __assign({ variant: "input", labelContent: label, errorNotification: { message: errorMessage }, name: name, id: name, ref: refValue, inputType: "text", inputMode: "numeric", value: displayValue, onBlur: combinedOnBlur, onFocus: combinedOnFocus, onChange: combinedOnChange, placeholder: "$0.00", maxLength: 12 }, (!isLgUp && { pattern: '[0-9]*' }), props)));
};
export default Amount;
//# sourceMappingURL=Amount.js.map